export default {

    months: [
        {Id: 0, Text: "января"},
        {Id: 1, Text: "февраля"},
        {Id: 2, Text: "марта"},
        {Id: 3, Text: "апреля"},
        {Id: 4, Text: "мая"},
        {Id: 5, Text: "июня"},
        {Id: 6, Text: "июля"},
        {Id: 7, Text: "августа"},
        {Id: 8, Text: "сентября"},
        {Id: 9, Text: "октября"},
        {Id: 10, Text: "ноября"},
        {Id: 11, Text: "декабря"}
    ],

    AuditType: [
        {Id: 1, Text: "Полевая активность"},
        {Id: 2, Text: "Горячая линия"},
        {Id: 3, Text: "Я-инспектор"}        
    ],

    AuditStatus: [
        {Id: 1, Text: "В работе"},
        {Id: 2, Text: "Завершен"},
        {Id: 3, Text: "Отправлен"},
        {Id: 4, Text: "Удален"}        
    ],

    FormStatus: [
        {Id: 0, Text: "empty", rus: "Неизвестно"},
        {Id: 1, Text: "yellow", rus: "В работе"},
        {Id: 2, Text: "green", rus: "Завершено"}
    ],

    FormPlace: [
        {Id: 1, Text: 'start'},
        {Id: 2, Text: 'regular'},
        {Id: 3, Text: 'end'},
        {Id: 4, Text: 'magnit'}
    ],

    MagnitQuestionStatus: [
        {Id: 0, Text: 'invalId'},
        {Id: 1, Text: 'notAnswered'},
        {Id: 2, Text: 'answered'}
    ],

    TaskStatus: [
        {Id: 1, Text: 'ongoing'},
        {Id: 2, Text: 'complete'},
        {Id: 3, Text: 'deleted'}
    ],

    UserStatus: [
        { Id: 0, Text: "Неизвестен" },
        { Id: 1, Text: "Активный" },
        { Id: 2, Text: "Архивный" },
    ],

    UserRights: [
      { Id: 0, Text: "Неизвестен" },
      { Id: 1, Text: "Администратор" },
      { Id: 2, Text: "Аудитор" },
      { Id: 3, Text: "Инспектор" },
      { Id: 4, Text: "Сервис" },
      { Id: 5, Text: "Не зарегистрирован в DAX" }
    ],

    TradePointType: [
      {Id : 1, Text: 'ЭТК', color: '#FFC232'},
      {Id : 2, Text: 'ОП', color: '#93CE4D'},
      {Id : 3, Text: 'Census', color: '#53a0ee'},
      {Id : 4, Text: 'NKA', color: '#976CC0'},
      {Id : 5, Text: 'LKA', color: '#E95948'},
      {Id : 6, Text: 'PM', color: '#2122a2'},
    ],

    TradePointMaxCount: 200,

    DisplayTTs: [
        {Id: 1, Text: 'All'}, /* Все ТТ */
		{Id: 2, Text: 'EmployesRoutes'}, /* ТТ из маршрутов сотрудников */
		{Id: 3, Text: 'Employes'},/* ТТ сотрудников */
		{Id: 4, Text: 'MyRoutes'}, /* Мой маршрут */
		{Id: 5, Text: 'My'} /* Мои ТТ */
    ],

    CategoryAep: [
        { Id: 0, Text: 'Неизвестен' },
        { Id: 1, Text: 'Чай' },
        { Id: 2, Text: 'Кофе' }
    ],

    SegmentCodes: [
        { Id: 0, Text: 'Неизвестен' },
        { Id: 1, Text: 'S0' },
        { Id: 2, Text: 'S1' },
        { Id: 3, Text: 'S2' },
        { Id: 4, Text: 'S3' },
        { Id: 5, Text: 'S4' },
        { Id: 6, Text: 'S5' },
        { Id: 7, Text: '< 50' },
        { Id: 8, Text: '>= 50' }
    ],

    TradePointSubType: [
        { Id: 0, Text: 'CST' },
        { Id: 1, Text: 'PAV' },
        { Id: 2, Text: 'SPT' },
        { Id: 3, Text: 'RMP' },
        { Id: 4, Text: 'WHS' },
        { Id: 5, Text: 'SPM' },
        { Id: 6, Text: 'PAL' },
        { Id: 7, Text: 'FFD' },
        { Id: 8, Text: 'PW' },
        { Id: 9, Text: 'GPM' },
        { Id: 10, Text: 'GS' },
        { Id: 11, Text: 'DC' },
        { Id: 12, Text: 'SDIS' },
        { Id: 13, Text: 'KET' },
        { Id: 14, Text: 'SC' },
        { Id: 15, Text: 'HOT' },
        { Id: 16, Text: 'DCH' },
        { Id: 17, Text: 'ES' },
        { Id: 18, Text: 'DIS' },
        { Id: 19, Text: 'NAR'},
        { Id: 20, Text: 'HD'},
        { Id: 21, Text: 'ALC' },
        { Id: 22, Text: 'STN' },
        { Id: 23, Text: 'SPR' },
        { Id: 24, Text: 'CF' },
        { Id: 25, Text: 'BK' },
        { Id: 26, Text: 'RES' },
        { Id: 27, Text: 'CAN' },
        { Id: 28, Text: 'PZZ' },
        { Id: 29, Text: 'GST' },
    ]
}